import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  editTextButtonAlt: {
    id: 'course-authoring.inplace-text-editor.button.alt',
    defaultMessage: 'Edit',
    description: 'Alt text for edit text icon button',
  },
});

export default messages;
